import { render } from "./RegisterForUpdates.vue?vue&type=template&id=7ae60134&scoped=true&ts=true"
import script from "./RegisterForUpdates.vue?vue&type=script&lang=ts"
export * from "./RegisterForUpdates.vue?vue&type=script&lang=ts"

import "./RegisterForUpdates.vue?vue&type=style&index=0&id=7ae60134&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae60134"]])

export default __exports__